import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TGender } from "../../Types";

export const apiCallGetMatchesIds = async ({
  khattabaUUID,
  userID,
  userUUID,
  matchGender,
  matchAppLanguage,
  minAge,
  maxAge,
  minWeight,
  maxWeight,
  minHeight,
  maxHeight,
  countryCode,
  nationalityCode,
  residenceCity,
  isChosenNationalitiesExcluded,
  isChosenResidenceCountriesExcluded,
  typeOfMarriage,
  maritalStatus,
  havingKids,
  work,
  education,
  femaleWorkOrStudy,
  smoking,
  belongsToATribe,
  relocation,
  skinColor,
  religion,
  veil,
  limit
}: {
  khattabaUUID: string;
  userID: number;
  userUUID: string;
  matchGender: TGender;
  matchAppLanguage: string;
  minAge: number;
  maxAge: number;
  minWeight: number;
  maxWeight: number;
  minHeight: number;
  maxHeight: number;
  countryCode: string[];
  nationalityCode: string[];
  residenceCity: string[];
  isChosenNationalitiesExcluded: boolean;
  isChosenResidenceCountriesExcluded: boolean;
  typeOfMarriage: string[];
  maritalStatus: string[];
  havingKids: string;
  work: string[];
  education: string[];
  femaleWorkOrStudy: string;
  smoking: string;
  belongsToATribe: string;
  relocation: string;
  skinColor: string[];
  religion: string[];
  veil: string[];
  limit: number;
}): Promise<{
  data: number[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<number[]>(
    `khattabat/get101MMatchesIds`,
    {
      khattabaUUID,
      userID,
      userUUID,
      matchGender,
      matchAppLanguage,
      minAge,
      maxAge,
      minWeight,
      maxWeight,
      minHeight,
      maxHeight,
      countryCode,
      nationalityCode,
      isChosenNationalitiesExcluded,
      isChosenResidenceCountriesExcluded,
      residenceCity,
      typeOfMarriage,
      maritalStatus,
      havingKids,
      work,
      education,
      femaleWorkOrStudy,
      smoking,
      belongsToATribe,
      relocation,
      skinColor,
      religion,
      veil,
      limit
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
